<template>
    <div>
        <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->

        </base-header>

        <div class="container-fluid mt--7">
            <div class="card shadow bg-secondary">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12 col-sm-6 align-self-center"><h3 class="mb-0">Accident details</h3></div>
                        <div class="col-12 col-sm-6 text-right align-self-center">
                            <router-link :to="{ name: 'accidents' }" class=" btn btn-secondary btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-arrow-left"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0 pt-md-4">
                    <h6 class="heading-small text-muted mb-4">User information</h6>
                    <div>
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive mb-4">
                                    <table class="table tablesorter">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    First name:
                                                </td>
                                                <td>
                                                    {{accident.firstName}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Last name:
                                                </td>
                                                <td>
                                                    {{accident.lastName}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Phone number:
                                                </td>
                                                <td>
                                                    {{accident.phone}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Policy:
                                                </td>
                                                <td>
                                                    <router-link
                                                    :to="{ name: 'task update', params: { id: accident.policyId } }"
                                                    class="font-weight-normal text-uppercase">
                                                        {{accident.policyId}}
                                                    </router-link>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 class="heading-small text-muted mb-4">Location information</h6>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col">
                                <div class="card shadow border-0">
                                    <div id="map-canvas" class="map-canvas" data-lat="40.748817" data-lng="-73.985428" style="height: 600px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import firebase from '../config/db.js';
    import swal from 'sweetalert2'

    export default {
        data() {
            return {
                id: this.$router.currentRoute.params.id,
                accident: {}
            }
        },
        mounted: function () {
            this.getAccidentData();
        },
        methods: {
            getAccidentData: function () {
                var that = this;
                firebase.firestore().collection("accidents").doc(this.id).get().then((doc) => {
                    if (doc.exists) {
                        that.accident = doc.data();
                        that.loadMap();
                    } else {
                        // doc.data() will be undefined in this case
                        swal.fire({
                            text: 'No such document!',
                            type: "error",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        that.$router.replace('accidents');
                    }
                });
            },
            loadMap: function () {
                var that = this;
                let google= window.google
                let map = document.getElementById('map-canvas');
                let lat = that.accident.location.u_;
                let lng = that.accident.location.h_;

                const myLatlng = new google.maps.LatLng(lat, lng);
                const mapOptions = {
                    zoom: 17,
                    scrollwheel: false,
                    center: myLatlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [
                    {"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},
                    {"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},
                    {"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},
                    {"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},
                    {"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},
                    {"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
                    {"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},
                    {"featureType":"water","elementType":"all","stylers":[{"color":'#5e72e4'},{"visibility":"on"}]}]
                }
                map = new google.maps.Map(map, mapOptions);

                new google.maps.Marker({
                    position: myLatlng,
                    map: map,
                    animation: google.maps.Animation.DROP,
                });
            }
        }
    };
</script>
<style></style>
